import { create } from 'zustand';
import { Session } from '@supabase/supabase-js';

interface User {
    id: string;
    email: string;
    role: 'admin' | 'employee';
    name: string;
    org_id: string;
}

interface AuthState {
    user: User | null;
    session: Session | null;
    userRole: 'admin' | 'employee' | null;
    setAuth: (data: { user: User; session: Session }) => void;
    clearAuth: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
    user: null,
    session: null,
    userRole: null,
    setAuth: (data) => set({ 
        user: data.user, 
        session: data.session,
        userRole: data.user.role 
    }),
    clearAuth: () => set({ user: null, session: null, userRole: null })
})); 